import {gsap} from 'gsap';
import {TweenMax} from "gsap/gsap-core";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.config({
    nullTargetWarn: false,
});

// Visitors who ask their system to limit motion get no animation from this file.
// Read once at page load; changing the setting takes effect on the next load.
// The matching CSS start states sit behind prefers-reduced-motion: no-preference,
// so skipping a tween here never leaves content hidden or out of place.
const motionIsReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

let scale = 1.09;


if (! motionIsReduced) {
    // Teasers
    const teaserAnimations = gsap.utils.toArray('.teaser-animation');

    Array.from(teaserAnimations).forEach(teaserAnimation => {
        const teasers = gsap.utils.toArray(teaserAnimation.querySelectorAll('.views-row, .photo, .teaser'));

        Array.from(teasers).forEach((teaser, index) => {
            teaserAnimationFunction(teaser, index);
        });
    });


    // Country page header image
    gsap.to('.page-node-type-country .section-header .field--name-field-background-image img', {
        scrollTrigger: {
            trigger: '.page-node-type-country .section-header',
            start: 'top top',
            end: 'bottom top',
            scrub: 1,
            pin: '.page-node-type-country .field--name-field-background-image'
        },
        scale: scale
    });

    gsap.to('.page-node-type-country .section-header .overlay', {
        scrollTrigger: {
            trigger: '.page-node-type-country .section-header',
            start: 'top top',
            end: 'bottom top',
            scrub: 1,
            pin: '.page-node-type-country .overlay'
        },
        opacity: 0.6
    });


    // Header paragraph image
    gsap.to('body:not(.page-node-type-homepage) .paragraph--type-header-bg-image-and-text .field--name-field-background-image, body:not(.page-node-type-homepage) .paragraph--type-header-video .field--name-field-video', {
        scrollTrigger: {
            trigger: '.section-header',
            start: 'top top',
            end: 'bottom top',
            scrub: 1,
        },
        scale: scale
    })

    // Homepage header text
    let headerTimeline = gsap.timeline();

    // Homepage header image
    headerTimeline.to('.page-node-type-homepage .paragraph--type-header-bg-image-and-text .field--name-field-background-image, .page-node-type-homepage .paragraph--type-header-video .field--name-field-video', {
        duration: 3,
        scale: scale,
        delay: 0.2
    })

    // Homepage header text
    const homepageHeaderText = gsap.utils.toArray('.page-node-type-homepage .section-body .field--name-field-header-text > *');

    homepageHeaderText.forEach((element, index) => {
        if (index !== 0) {
            headerTimeline.to(element, {
                y: 0,
                opacity: 1,
                duration: 1,
                delay: 0
            }, '-=0.5');
        }

        headerTimeline.to(element, {
            y: 0,
            opacity: 1,
            duration: 1,
        }, '-=3');
    })

    // Homepage header read more
    headerTimeline.to('.page-node-type-homepage .read-more-down', {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: 0
    }, '-=2');

    // Quotes
    const quoteParagraphs = gsap.utils.toArray('.paragraph--type-quote, .paragraph--type-bg-image-title-and-cta');

    Array.from(quoteParagraphs).forEach(quote => {
        gsap.to(quote.querySelector('.field--name-field-background-image'), {
            scrollTrigger: {
                trigger: quote,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
            },
            scale: scale
        })
    });
}


// Statistics counter
function numberWithCommas(n) {
    let parts = n.toString().split(".");

    if (document.documentElement.lang === 'en') {
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

let statisticsParagraphs = document.getElementsByClassName('paragraph--type--statistic-number-with-text');

Array.from(statisticsParagraphs).forEach(paragraph => {
    let numbers = paragraph.querySelectorAll('.field--name-field-number');

    Array.from(numbers).forEach(number => {

        // The template renders a literal 0 and carries the target in data-count,
        // so dropping the count up means writing the end value ourselves.
        if (motionIsReduced) {
            number.innerHTML = numberWithCommas(parseFloat(number.dataset.count));

            return;
        }

        let counter = {var: 0};

        TweenMax.to(counter, 2, {
            scrollTrigger: {
                trigger: number,
                start: 'top bottom',
            },
            var: number.dataset.count,
            onUpdate: function () {
                let nwc = numberWithCommas(counter.var);
                number.innerHTML = nwc;
            },
            ease: 'circ.out'
        });
    });
});


if (! motionIsReduced) {
    // Text with image paragraphs
    const textAndImageParagraph = gsap.utils.toArray('.layout-intro-block-text-image-paragraph, .layout-text-with-image-paragraph, .layout-contact-person-paragraph');

    Array.from(textAndImageParagraph).forEach(paragraph => {
        gsap.to(paragraph.querySelector('.field--type-image img'), {
            scrollTrigger: {
                trigger: paragraph,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1
            },
            y: '-5%'
        });
    });


    // Donation blocks
    const donationBlocks = gsap.utils.toArray('.paragraph--type-donation-block');

    Array.from(donationBlocks).forEach(donationBlock => {
        gsap.to(donationBlock.querySelector('.inner'), {
            scrollTrigger: {
                trigger: donationBlock,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1
            },
            y: '-5%'
        });
    });
}


// Makes card clickable
// Opens link in new window when link has a type attribute
function clickableCard() {
    let link = this.getElementsByTagName('A')[0];

    if (link.hasAttribute('type')) {
        window.open(link, '_blank');
    } else {
        window.open(link, '_self');
    }
}


function teaserAnimationFunction(teaser, index) {
    // Also reached from the Drupal behaviors below, which run again on every
    // infinite scroll load, so the guard belongs here rather than at the call site.
    if (motionIsReduced) {
        return;
    }

    gsap.to(teaser, {
        scrollTrigger: {
            trigger: teaser,
            start: 'top bottom',
            end: 'center 10%',
            scrub: 1,
        },
        y: 0,
        delay: index * 1.2
    });
}


(function ($, Drupal) {
    Drupal.behaviors.activityItemOverview = {
        attach: function (context, settings) {
            once('activityItem', '.activity-row-item', context).forEach(function(item, index) {
                teaserAnimationFunction(item, index);

                item.addEventListener('click', clickableCard, false);
                item.style.cursor = 'pointer';
            });
        }
    };
})(jQuery, Drupal);

(function ($, Drupal) {
    Drupal.behaviors.campaignItemOverview = {
        attach: function (context, settings) {
            once('campaignItem', '.campaign-row-item', context).forEach(function(item, index) {
                teaserAnimationFunction(item, index);

                item.addEventListener('click', clickableCard, false);
                item.style.cursor = 'pointer';
            });
        }
    };
})(jQuery, Drupal);
